/**
 * Inference provider detection.
 *
 * The source of truth is the user's inference_settings in TimescaleDB.
 * At install time, `/api/v1/cli/me` returns `local_inference: true` when
 * `gradingProvider = 'claude-code'`. The install flow writes
 * `SYNKRO_LOCAL_INFERENCE='yes'` into ~/.synkro/config.env.
 *
 * At runtime the hook scripts use a TCP probe (synkro_channel_up) to decide
 * routing — this module is only used by CLI commands and intent routers.
 */

import { existsSync, readFileSync } from 'node:fs';
import { homedir } from 'node:os';
import { join } from 'node:path';

const CONFIG_PATH = join(homedir(), '.synkro', 'config.env');

export function isLocalCCEnabled(): boolean {
  if (!existsSync(CONFIG_PATH)) return false;
  try {
    const content = readFileSync(CONFIG_PATH, 'utf-8');
    const match = content.match(/^SYNKRO_LOCAL_INFERENCE='([^']*)'/m);
    return match?.[1] === 'yes';
  } catch {
    return false;
  }
}
